export default "__VITE_ASSET__uOsNvqg0__"